import { createFileRoute } from '@tanstack/react-router'
import DesignSystemPage from '@/spa/pages/DesignSystemPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/design-system')({
  component: DesignSystemPage,
  errorComponent: routeErrorComponent,
})
